window.jQuery = window.$ = require('jquery');
require('jquery-migrate');
require('angular');
require('react');
require('react-dom');
//require('react-native-web');
require('bootstrap');
require('bootstrap-hover-dropdown');
require('bootstrap-switch');
require('../webroot/assets/global/plugins/jquery-slimscroll/jquery.slimscroll.min.js');
require('../webroot/assets/global/plugins/jquery-validation/js/jquery.validate.min.js');
require('../webroot/assets/global/plugins/jquery.blockui.min.js');
require('js-cookie');
window._ = require('lodash');
window.moment = require('moment');
